export default "__VITE_ASSET__CTuOQYsf__"